/**
 * Standard analytics event names.
 *
 * All event names follow the SCREAMING_SNAKE_CASE convention and map to
 * human-readable labels sent to GA4 and Mixpanel.
 */

export const AnalyticsEvents = {
  // Navigation
  PAGE_VIEW: 'page_view',

  // Waitlist / Lead-gen
  WAITLIST_SIGNUP: 'waitlist_signup',
  WAITLIST_FORM_STARTED: 'waitlist_form_started',

  // CTA interactions
  CTA_CLICK: 'cta_click',

  // Authentication
  LOGIN: 'login',
  LOGOUT: 'logout',
  SIGNUP: 'signup',

  // Trading
  ORDER_SUBMITTED: 'order_submitted',
  ORDER_CANCELLED: 'order_cancelled',

  // Custody quick actions (on /trade)
  TRADE_QUICK_DEPOSIT_CLICKED: 'trade_quick_deposit_clicked',
  TRADE_QUICK_WITHDRAW_CLICKED: 'trade_quick_withdraw_clicked',
  TRADE_QUICK_ACTION_COMPLETED: 'trade_quick_action_completed',

  // Onboarding
  KYC_STARTED: 'kyc_started',
  KYC_COMPLETED: 'kyc_completed',
  BANK_LINKED: 'bank_linked',

  // Settings
  SETTINGS_UPDATED: 'settings_updated',
} as const;

export type AnalyticsEventName = (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents];
